module.exports = __webpack_public_path__ + "static/media/404.ea0a4425.png";